/* Design System — palette violet / rose / dark */

export const designSystemColors = {
  /* Sémantiques (design_system.md) */
  background: "#050505",
  foreground: "#f2f2f2",
  card: "#0d0d0d",
  "card-foreground": "#f2f2f2",
  muted: "#1f1f1f",
  "muted-foreground": "#999999",
  border: "#242424",
  input: "#242424",
  destructive: "#ef4444",
  neon: "#d4ff00",
  /* Primary — violet #8B5CF6 */
  primary: {
    50: "#f5f3ff",
    100: "#ede9fe",
    200: "#ddd6fe",
    300: "#c4b5fd",
    400: "#a78bfa",
    500: "#8B5CF6",
    600: "#7c3aed",
    700: "#6d28d9",
    800: "#5b21b6",
    900: "#4c1d95",
  },
  /* Accent — rose #EC4899 */
  accent: {
    50: "#fdf2f8",
    100: "#fce7f3",
    200: "#fbcfe8",
    300: "#f9a8d4",
    400: "#f472b6",
    500: "#EC4899",
    600: "#db2777",
    700: "#be185d",
    800: "#9d174d",
    900: "#831843",
  },
  /* Gris alignés dark mode */
  gray: {
    50: "#fafafa",
    100: "#f4f4f5",
    200: "#e4e4e7",
    300: "#d4d4d8",
    400: "#a1a1aa",
    500: "#71717a",
    600: "#52525b",
    700: "#3f3f46",
    800: "#1a1a1a",
    900: "#050505",
  },
};

export const globalStyles = {
  initialColorMode: "dark",
  colors: {
    ...designSystemColors,
    brand: designSystemColors.primary,
  },
  styles: {
    global: (props) => ({
      body: {
        fontFamily: "Roboto, sans-serif",
        bg: "background",
        color: "foreground",
      },
      "*::-webkit-scrollbar": {
        display: "none",
      },
      "*": {
        msOverflowStyle: "none",
        scrollbarWidth: "none",
      },
      "*::placeholder": {
        color: "muted-foreground",
      },
      html: {
        fontFamily: "Roboto, sans-serif",
      },
      h1: {
        fontFamily: "Montserrat, sans-serif",
      },
      h2: {
        fontFamily: "Montserrat, sans-serif",
      },
      h3: {
        fontFamily: "Montserrat, sans-serif",
      },
      h4: {
        fontFamily: "Montserrat, sans-serif",
      },
      h5: {
        fontFamily: "Montserrat, sans-serif",
      },
      h6: {
        fontFamily: "Montserrat, sans-serif",
      },
    }),
  },
};
